import { createContext, useContext, useEffect, useState } from "react";

// Static FX rates (USD baseline). Synced with backend FX_RATES.
export const FX_RATES = {
  USD: 1.0, EUR: 0.93, GBP: 0.79,
  CAD: 1.35, AED: 3.67, SAR: 3.75,
};

export const SUPPORTED_CURRENCIES = [
  { code: "USD", symbol: "$", label: "US Dollar" },
  { code: "EUR", symbol: "€", label: "Euro" },
  { code: "GBP", symbol: "£", label: "Pound Sterling" },
  { code: "CAD", symbol: "C$", label: "Canadian Dollar" },
  { code: "AED", symbol: "د.إ", label: "UAE Dirham" },
  { code: "SAR", symbol: "﷼", label: "Saudi Riyal" },
];

const CurrencyContext = createContext({ currency: "USD", setCurrency: () => {} });

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => localStorage.getItem("bid_currency") || "USD");

  const setCurrency = (c) => {
    setCurrencyState(c);
    localStorage.setItem("bid_currency", c);
  };

  useEffect(() => {
    localStorage.setItem("bid_currency", currency);
  }, [currency]);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);

export const convertUsd = (amountUsd, currency) => {
  const rate = FX_RATES[currency] || 1;
  return amountUsd * rate;
};

export const formatPrice = (amountUsd, currency, opts = {}) => {
  const value = convertUsd(amountUsd, currency);
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      maximumFractionDigits: opts.decimals ?? 0,
      minimumFractionDigits: opts.decimals ?? 0,
    }).format(value);
  } catch {
    const sym = SUPPORTED_CURRENCIES.find(c => c.code === currency)?.symbol || "$";
    return `${sym}${value.toLocaleString(undefined, { maximumFractionDigits: opts.decimals ?? 0 })}`;
  }
};
